var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { rem } from '../../../utils/rem';
import { palette } from '../palette';
import { typography } from '../typography';
export var MuiFormHelperText = {
    styleOverrides: {
        root: __assign({ color: (_a = palette === null || palette === void 0 ? void 0 : palette.text) === null || _a === void 0 ? void 0 : _a.secondary, margin: 0, marginTop: rem(4) }, typography === null || typography === void 0 ? void 0 : typography.body2),
        contained: {
            marginInlineStart: 0,
        },
    },
};
